// extracted by mini-css-extract-plugin
export default {"input":"Input_input__NfOk0","error":"Input_error__VUP2R"};